import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { PublicacaoService } from 'src/app/services/publicacao.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PublicacaoEditarComponent } from './publicacao-editar/publicacao-editar.component';

@Component({
    selector: 'app-publicacoes',
    templateUrl: './publicacoes.component.html',
    styleUrls: ['./publicacoes.component.css']
})
export class PublicacoesComponent implements OnInit {
    apllyFilterPublicType: boolean;
    textoFiltro: string;
    sortDesc = true;

    constructor(
        public publicacaoService: PublicacaoService,
        private spinner: NgxSpinnerService,
        private ngbModal: NgbModal,
    ) { }

    public selecionado: boolean = false;
    public sortAsc: boolean = false;
    public sortBy: string = 'dataCriacao';
    public itensPorPaginaInicial: number = 500;
    public itensPorPaginaIncremental: number = 50;
    public itensPorPagina: number = this.itensPorPaginaInicial;
    public totalItens: number = 0;
    public activeTab = 1;
    public idsPublicacoesSelecionadas = new Set<string>();
    private chaveEstadoTela = 'publicacoes:filtros';
    public publicacaoVMFilter: any = {
        asc: false,
        campoSort: 'dataCriacao',
        quantidade: 0,
        pagina: this.itensPorPaginaInicial,
        campoBusca: 'numeroProcesso',
        filtroTela: false,
        calcularTotal: false,
        publicacaoInternas: false

    }

    public swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-padrao btn-lg mr-3',
            cancelButton: 'btn btn-default btn-lg'
        },
        buttonsStyling: false
    });

    public barChartOptions: ChartOptions = {

        legend: {
            display: false
        },
        responsive: true,
        scales: {

            yAxes: [{
                ticks: {
                    display: false
                },
                gridLines: {
                    display: false
                }
            }],
            xAxes: [{
                gridLines: {
                    display: false
                }
            }]
        }

    };
    public barChartLabels: Label[] = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
    public barChartType: ChartType = 'bar';
    public barChartLegend = false;
    public barChartPlugins = [];

    public publicacoes: any;

    public publicacoesOriginal: any;

    public detalhes = {
        recebidasHoje: 0,
        tratadasHoje: 0,
        descartadasHoje: 0,
        naoTratadas: 0
    }

    public barChartData: ChartDataSets[] = [
        { data: [0, 0, 0, 0, 0, 0, 0] }
    ];

    public dataHeaderFilter = [];

    public loadPublicacoesExternas = false;
    public loadPublicacoesInternas = false;
    
    ngOnInit(): void {

        if (!this.restaurarEstadoTela()) {
            this.zerarFiltros();
            this.obterFiltroTratamento('nao_tratado');
        }
    }


    verificarPublicacoesInternas() {
        return this.activeTab == 1 ? false : true;
    }

    getPublicacoes() {
        console.log(this.activeTab);
        this.zerarFiltros();
        this.obterFiltroTratamento('nao_tratado');
    }

    zerarFiltros() {
        this.publicacaoVMFilter = {
            asc: false,
            campoSort: 'dataCriacao',
            quantidade: 0,
            pagina: this.itensPorPagina,
            campoBusca: 'numeroProcesso',
            filtroTela: false,
            calcularTotal: false,
            publicacaoInternas: this.activeTab == 1 ? false : true
            
        }
        this.totalItens = 0;
        this.publicacoes = undefined;
        this.publicacoesOriginal = undefined;
        this.selecionado = false;
    }

    setSort(key: string) {
        if (this.sortBy !== key) {
            this.sortBy = key;
            this.sortDesc = false;
        } else {
            this.sortDesc = !this.sortDesc;
        }

        this.publicacaoVMFilter.campoSort = key;
        this.publicacaoVMFilter.asc = !this.sortDesc;
        this.publicacaoVMFilter.quantidade = 0;
        this.publicacaoVMFilter.pagina = this.itensPorPagina;
        this.publicacoes = undefined;
        this.publicacoesOriginal = undefined;
        this.salvarEstadoTela();
        this.carregarPublicacoes();
    }

    carregarDetalhes() {
        this.publicacaoService.getDetails(this.activeTab == 1 ? false : true).subscribe(res => {
            this.detalhes = res.data;
            this.dataHeaderFilter = [
                {
                    onFilter: () => this.obterFiltroTratamento("recebidas_hoje"),
                    value: this.detalhes.recebidasHoje,
                    label: 'Recebidas hoje'
                },
                {
                    onFilter: () => this.obterFiltroTratamento("tratadas_hoje"),
                    value: this.detalhes.tratadasHoje,
                    label: 'Tratadas hoje'
                },
                {
                    onFilter: () => this.obterFiltroTratamento("descartados_hoje"),
                    value: this.detalhes.descartadasHoje,
                    label: 'Descartadas hoje'
                },
                {
                    onFilter: () => this.obterFiltroTratamento("nao_tratado"),
                    value: this.detalhes.naoTratadas,
                    label: 'Não tratadas'
                },
            ]

            let bar: ChartDataSets[] = [{
                data: []
            }
            ];

            for (let i = 0; i < 7; i++) {
                bar[0].data.push(res.data.quantidadeDiasDaSemana[i].quantidadeTotal);
            }

            this.barChartData = bar;
        })
    }

    buscar() {
        this.publicacaoVMFilter.quantidade = 0;
        this.publicacaoVMFilter.pagina = this.itensPorPagina;
        this.publicacaoVMFilter.publicacaoInternas = this.activeTab == 1 ? false : true;
        this.publicacoes = undefined;
        this.publicacoesOriginal = undefined;
        this.salvarEstadoTela();
        this.carregarPublicacoes();
    }

    limparFiltros() {

        this.textoFiltro = null;
        this.idsPublicacoesSelecionadas.clear();
        localStorage.removeItem(this.chaveEstadoTela);
        this.zerarFiltros();
        this.carregarPublicacoes();
    }

    obterFiltroTratamento(filtro_tratamento: string) {
        this.zerarFiltros();
        if (this.activeTab == 1) this.loadPublicacoesExternas = true;
        if (this.activeTab == 2) this.loadPublicacoesInternas = true;
        this.publicacaoVMFilter.campoBusca = filtro_tratamento;
        this.publicacaoVMFilter.filtroTela = true;
        this.publicacaoVMFilter.quantidade = 0;
        this.publicacaoVMFilter.pagina = this.itensPorPagina;
        this.publicacaoVMFilter.publicacaoInternas= this.activeTab == 1 ? false : true;
        this.publicacoes = undefined;
        this.publicacoesOriginal = undefined;

        this.definirTextoFiltro(filtro_tratamento);
        this.publicacaoVMFilter.textoFiltro = this.definirFiltroTexto(this.textoFiltro);
        this.salvarEstadoTela();
        this.carregarPublicacoes();
    }

    carregarPublicacoes(atualizarDetalhes: boolean = true) {

        this.spinner.show();

        this.publicacaoService.filterPagination(this.publicacaoVMFilter)
            .subscribe(res => {
                const itens = this.prepararPublicacoes(res.data.itens ?? []);
                
                if (this.publicacoes == undefined) {
                    this.publicacoes = itens;
                    this.publicacoesOriginal = itens;
                } else {
                    this.publicacoes = this.publicacoes.concat(itens);
                    this.publicacoesOriginal = this.publicacoes;
                }

                this.totalItens = res.data.paginacao.totalItens;

                this.publicacaoVMFilter.quantidade += itens.length;
                this.sincronizarSelecoesNaLista();

                if (atualizarDetalhes) {
                    this.carregarDetalhes();
                }

                this.loadPublicacoesExternas = false;
                this.loadPublicacoesInternas = false;
                this.spinner.hide();
            })
    }

    prepararPublicacoes(publicacoes) {
        publicacoes.forEach(element => {
            if(element.detalhamento && element.detalhamento.length > 100){
                element.detalhamentoResumo = element.detalhamento.substring(0,100) + "...";
            }else{
                element.detalhamentoResumo = element.detalhamento;
            }

            element.dataDivulgacaoFormatada = this.formatarData(element.dataDivulgacao);
            element.dataPublicacaoFormatada = this.formatarData(element.dataPublicacao);
            element.dataCriacaoFormatada = this.formatarData(element.dataCriacao);
        });

        return publicacoes;
    }

    formatarData(valor): string {
        if (!valor) return '';

        const data = new Date(valor);
        if (isNaN(data.getTime())) return '';

        const dia = data.getDate().toString().padStart(2, '0');
        const mes = (data.getMonth() + 1).toString().padStart(2, '0');
        const ano = data.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    carregarMais() {
        if (!this.possuiMaisPublicacoes()) return;

        this.publicacaoVMFilter.pagina = this.itensPorPaginaIncremental;
        this.carregarPublicacoes(false);
    }

    possuiMaisPublicacoes(): boolean {
        return (this.publicacoes?.length ?? 0) < this.totalItens;
    }

    marcarTodasPublicacoes(selecionado: boolean) {

        this.publicacoes.forEach(element => {
            this.alterarSelecao(element.id, selecionado);
        });
    }

    possuiSelecionadas(): boolean {
        return this.idsPublicacoesSelecionadas.size > 0;
    }

    descartarPublicacoesSelecionadas() {
        const publicacoesSelecionadas = this.publicacoes.filter(c => this.idsPublicacoesSelecionadas.has(c.id));
        if(!publicacoesSelecionadas.length) {
            this.swalWithBootstrapButtons.fire('Selecione publicacoes para descartar!','Atencao','warning');
            return;
        }
        
        const ids = publicacoesSelecionadas.filter(p => p.tipoSituacaoPublicacao == 1).map(p => p.id)  ?? [];
        if (!ids.length) return;

        this.descartarPublicacacoes(ids);
    }

    descartarPublicacaoPorId(idPublicacao) {
        this.descartarPublicacacoes([idPublicacao]);
    }

    descartarPublicacacoes(ids){
        this.swalWithBootstrapButtons.fire({
            text: `Deseja descartar ${(ids.length > 1) ? ' as publicações selecionadas?' : ' a publicação' }`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                this.spinner.show();
                this.publicacaoService.descartarPublicacoes(ids)
                .subscribe(res => {
                    ids.forEach(id => this.idsPublicacoesSelecionadas.delete(id));
                    this.sincronizarSelecoesNaLista();
                    this.spinner.hide();
                    ids.forEach(id => this.atualizarPublicacaoNaLista(id));
                    this.carregarDetalhes();
                }, error => {
    
                    this.spinner.hide();
    
                    this.swalWithBootstrapButtons.fire('Não foi possível descartar a publicação!','','error'
                    );
                });
            }
        });
    }

    abrirPublicacao(idPublicacao): void {
        const modalRef = this.ngbModal.open(PublicacaoEditarComponent, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false
        });

        modalRef.componentInstance.modalRef = modalRef;
        modalRef.componentInstance.id = idPublicacao;

        modalRef.result
            .then(() => this.atualizarPublicacaoNaLista(idPublicacao))
            .catch(() => this.atualizarPublicacaoNaLista(idPublicacao));
    }

    publicacaoSelecionada(idPublicacao: string): boolean {
        return this.idsPublicacoesSelecionadas.has(idPublicacao);
    }

    trackByPublicacaoId(index: number, publicacao: any): string {
        return publicacao.id;
    }

    alterarSelecao(idPublicacao: string, selecionado: boolean): void {
        if (selecionado) {
            this.idsPublicacoesSelecionadas.add(idPublicacao);
        } else {
            this.idsPublicacoesSelecionadas.delete(idPublicacao);
        }

        const publicacao = this.publicacoes?.find(c => c.id === idPublicacao);
        if (publicacao) {
            publicacao.checked = selecionado;
        }

        this.selecionado = this.publicacoes?.length > 0 && this.publicacoes.every(c => this.idsPublicacoesSelecionadas.has(c.id));
    }

    sincronizarSelecoesNaLista(): void {
        if (!this.publicacoes) return;

        this.publicacoes.forEach(publicacao => {
            publicacao.checked = this.idsPublicacoesSelecionadas.has(publicacao.id);
        });

        this.selecionado = this.publicacoes.length > 0 && this.publicacoes.every(publicacao => publicacao.checked);
    }

    atualizarPublicacaoNaLista(idPublicacao: string): void {
        if (!this.publicacoes) return;

        const index = this.publicacoes.findIndex(publicacao => publicacao.id === idPublicacao);
        if (index < 0) return;

        this.publicacaoService.getById(idPublicacao)
            .subscribe(res => {
                const publicacaoAtualizada = this.prepararPublicacoes([{
                    ...this.publicacoes[index],
                    ...res.data,
                    checked: this.idsPublicacoesSelecionadas.has(idPublicacao)
                }])[0];

                this.publicacoes[index] = publicacaoAtualizada;
                this.publicacoesOriginal = this.publicacoes;
                this.spinner.hide();
            }, error => {
                this.spinner.hide();
            });
    }

    salvarEstadoTela(): void {
        localStorage.setItem(this.chaveEstadoTela, JSON.stringify({
            activeTab: this.activeTab,
            textoFiltro: this.textoFiltro,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
            publicacaoVMFilter: {
                ...this.publicacaoVMFilter,
                quantidade: 0,
                pagina: this.itensPorPaginaInicial
            }
        }));
    }

    restaurarEstadoTela(): boolean {
        const estado = localStorage.getItem(this.chaveEstadoTela);
        if (!estado) return false;

        try {
            const dados = JSON.parse(estado);
            this.activeTab = dados.activeTab || 1;
            this.textoFiltro = dados.textoFiltro;
            this.sortBy = dados.sortBy || 'dataCriacao';
            this.sortDesc = dados.sortDesc === undefined ? true : dados.sortDesc;
            this.publicacaoVMFilter = {
                ...dados.publicacaoVMFilter,
                quantidade: 0,
                pagina: this.itensPorPaginaInicial,
                publicacaoInternas: this.activeTab == 1 ? false : true
            };
            this.carregarPublicacoes();
            return true;
        } catch {
            localStorage.removeItem(this.chaveEstadoTela);
            return false;
        }
    }

    definirTextoFiltro(filtro): void {

        switch (filtro) {
            case "recebidas_hoje":
                this.textoFiltro = 'Recebidas hoje';
                break;
            case "tratadas_hoje":
                this.textoFiltro = 'Tratadas hoje';
                break;
            case "descartados_hoje":
                this.textoFiltro = 'Descartadas hoje';
                break;
            case "nao_tratado":
                this.textoFiltro = 'Não tratadas';
                break;
            default:
              this.textoFiltro = null;
              break
        }
    }
    definirFiltroTexto(filtro): string {

      switch (filtro) {
          case "Recebidas hoje":
              return 'recebidas_hoje';
          case "Tratadas hoje":
              return 'tratadas_hoje';
          case "Descartadas hoje":
              return 'descartados_hoje';
          case "Não tratadas":
            return 'nao_tratado'
          default:
            return null;
      }
  }
}
